import { styled } from '../../../hooks/theme';
import { getCssFont } from '../../../styles';
import { Tokens } from '../../../types';

import { ParagraphProps } from './Paragraph.types';

type PProps = ParagraphProps;

export const P = styled.p<PProps>`
  ${props => {
    const font =
      props.theme.font.desktop.paragraph[props.variant.toLowerCase()][props.fontWeight] ??
      props.theme.font.desktop.paragraph.p1.regular;
    return getCssFont(font);
  }};

  @media screen and (max-width: ${Tokens.breakpoints.mobile}px) {
    ${props => {
      const font =
        props.theme.font.desktop.paragraph[props.variant.toLowerCase()][props.fontWeight] ??
        props.theme.font.mobile.paragraph.p1.regular;
      return getCssFont(font);
    }};
  }
`;

P.defaultProps = {
  theme: Tokens.eixods,
};
